<template>
    <div>
        <div class="row py-4">
            <img :src="image" class="m-auto info-icon" alt="icon"
                 height="70">
        </div>

        <div class="row">
            <h5 class="m-auto caption py-3">{{title}}</h5>
        </div>

        <div class="row">
            <ul class="m-auto">
                <li v-for="(item, i) in items" :key="i">{{item}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoList",
        props: {
            icon: String,
            title: String,
            items: Array
        },
        computed: {
            image() {
                return require("@/assets/images/" + this.icon)
            }
        }
    }
</script>

<style scoped>

</style>